/**
 * @desc 分页
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.systemForecast.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/wms/systemForecast/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
